export const CATEGORIES = [
  { id: 'web', label: 'Web Applications', order: 1 },
  { id: 'network', label: 'Networks', order: 2 },
  { id: 'wireless', label: 'Wireless', order: 3 },
  { id: 'operating-systems', label: 'Operating Systems', order: 4 },
  { id: 'active-directory', label: 'Active Directory', order: 5 },
  { id: 'social-engineering', label: 'Social Engineering', order: 6 },
  { id: 'malware', label: 'Malware', order: 7 },
  { id: 'cloud', label: 'Cloud', order: 8 },
  { id: 'containers', label: 'Containers', order: 9 },
  { id: 'api', label: 'APIs', order: 10 },
  { id: 'hardware', label: 'Hardware', order: 11 },
  { id: 'physical-security', label: 'Physical Security', order: 12 },
  { id: 'supply-chain', label: 'Supply Chain', order: 13 },
  { id: 'cryptography', label: 'Cryptography', order: 14 },
  { id: 'ai-llm', label: 'AI / LLM Attacks', order: 15 },
  { id: 'uncategorized', label: 'Uncategorized', order: 99 },
] as const

export type CategoryId = (typeof CATEGORIES)[number]['id']

export function categoryPath(id: string): string {
  return id
}
